import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, PrivateIcon, PublicIcon, RadioCards, RowsContainer, } from '@streamr/tv-ui';
import { useMemo, useState } from 'react';
import styled from 'styled-components';
import { Popup, TopCenter, TopRight } from '../../../utils/popups';
import { AbstractPopup, DismissalReason, } from '../AbstractPopup';
import { ScrollablePopupContainer } from '../helpers/ScrollablePopupContainer';
import { PopupCssPreset } from '../Popup.styles';
const StartRecordingPopup = ({ reject, resolve, variant, ...props }) => {
    const options = useMemo(() => {
        return [
            {
                value: 'public',
                title: (_jsxs(OptionTitle, { children: [_jsx(PublicIcon, {}), " Public"] })),
                subtitle: 'Accessible via the link to this broadcast',
            },
            {
                value: 'private',
                title: (_jsxs(OptionTitle, { children: [_jsx(PrivateIcon, {}), " Private"] })),
                subtitle: 'Accessible only via a separate secret link',
            },
        ];
    }, []);
    const [value, setValue] = useState('public');
    return (_jsx(StartRecordingPopupRoot, { reject: reject, ...props, translateFn: variant === 'mobile' ? TopCenter : TopRight, className: variant, children: _jsx(ScrollablePopupContainer, { fullscreenOnly: variant === 'mobile', onCloseButtonClick: () => {
                reject(DismissalReason.CloseButton);
            }, children: _jsxs(RowsContainer, { children: [_jsx(RadioCards, { options: options, value: value, onChange: (value) => setValue(value) }), _jsx(StartButton, { type: "button", onClick: () => {
                            resolve(value);
                        }, children: "Start Recording" })] }) }) }));
};
const StartRecordingPopupRoot = styled(AbstractPopup) `    
    ${PopupCssPreset.Fullscreen};    
    --Popup_Padding: 0;

    &.desktop {
        @media (min-width: 30rem) {
            ${PopupCssPreset.AnchoredTopRight};
            --Popup_Height: auto;
            --Popup_Width: 25rem;
            --Popup_Padding: 1rem 0;
            --Popup_BorderRadius: var(--tv-ui-border-radius-2);

            /* Bring back offset transitions */
            --Popup_OffsetTransition: initial;
        }
    }

    &.mobile {
        --SettingsContainer_InnerMaxWidth: 25rem;
    }  
`;
const OptionTitle = styled.div `
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.5rem;
`;
const StartButton = styled(Button) `
    width: 100%;
    padding: 1rem 0;
    --Button_Background: var(--tv-ui-color-3);
    --Button_TextColor: var(--tv-ui-color-1);
    --Button_BorderRadius: 1rem;
    --Button_HoverTransform: scale(1.02);
    --Button_ActiveTransform: scale(1.02);

`;
const startRecordingPopup = Popup.create(StartRecordingPopup);
export async function showStartRecordingPopup({ anchorRef, variant, onBeforeOpen, onDismiss, }) {
    try {
        onBeforeOpen?.();
        return await startRecordingPopup.pop({
            anchorRef,
            variant,
        });
    }
    catch (_) {
    }
    finally {
        onDismiss?.();
    }
}
